import { combineEpics } from 'redux-observable';
import { of } from 'rxjs/observable/of';
import { mergeMap } from 'rxjs/operators/mergeMap';

import { START_WORLDPAY_MODAL } from '../actions/transaction';
import { OPEN_MODAL } from '../redux/modal';

import WorldpayIframe from '../components/WorldpayIframe';

const startWorldPayModalEpic = (action$, store, { baseUrl }) =>
  action$.ofType(START_WORLDPAY_MODAL).pipe(
    mergeMap(({ value }) => {
      const {
        paymentMethod: { url },
        totals,
        reservedOrderNumber,
      } = value;

      const modalContents = {
        content: (
          <WorldpayIframe
            url={url}
            iframeHelperURL={`${baseUrl}/iframeHelper.html`}
            iframeBaseURL={baseUrl}
            grandTotal={
              totals.find(({ id }) => id === 'grand_total').valueFormatted
            }
            orderNumber={reservedOrderNumber}
          />
        ),
        label: 'Payment',
      };

      return of({ type: OPEN_MODAL, value: modalContents });
    })
  );

const worldPayEpic = combineEpics(startWorldPayModalEpic);

export default worldPayEpic;
